import { useExplore } from '@/stores/explore';
import { Layer } from '@/stores/viewer';
import { cn } from '@/utils/classname';
import { persist } from '@/utils/Persist';
import { Button, Toast } from '@skand/ui';
import { useState } from 'react';
import { Checkbox } from '../Checkbox';

export interface LocationAlertModalProps {
  layer: Layer;
}

export const LocationAlertModal = ({ layer }: LocationAlertModalProps) => {
  const [isChecked, setIsChecked] = useState(false);
  const showPlaceLayerModal = useExplore(state => state.showPlaceLayerModal);
  const hidelLocationAlertModal = useExplore(state => state.hidelLocationAlertModal);

  const handlePlaceLayerModalClick = () => {
    hidelLocationAlertModal();
    showPlaceLayerModal();
  };

  const handleDismissModalClick = () => {
    const existing = persist.get('modelLocationIgnore') ?? [];
    const updated = Array.from(new Set([...existing, layer.id]));
    persist.set('modelLocationIgnore', updated);

    hidelLocationAlertModal();
  };

  return (
    <div className={cn('w-full flex flex-col p-0')}>
      <p className={cn('typo-text-medium', 'text-neutral-800', 'mb-2')}>Model Location</p>
      <Toast
        clickToDismiss
        dismiss={() => {}}
        message={`${layer.name} might be placed incorrectly`}
        props={{ className: 'shadow-none' }}
        type="info"
      />
      <p className={cn('typo-text-small', 'text-neutral-600', 'mb-5', 'mt-2')}>
        Would you like to place the model?
      </p>

      <label className="mb-3 flex items-center gap-3">
        <Checkbox checked={isChecked} setToggleCheckbox={setIsChecked} />
        <p className={cn('typo-text-small', 'text-neutral-600')}>Don’t show this message again</p>
      </label>

      <Button
        className={`w-full ${!isChecked ? 'hidden' : ''}`}
        filled
        onClick={handleDismissModalClick}
        primary
        size="s"
      >
        Dismiss
      </Button>

      <Button
        className={`w-full ${isChecked ? 'hidden' : ''}`}
        filled
        onClick={handlePlaceLayerModalClick}
        primary
        size="s"
      >
        Place model
      </Button>
    </div>
  );
};
